<template>
    <div>
        
         <div class="row" v-if="userData" style="padding : 0 1%">
            <div class="col-md-3 col-sm-12 border border-secondary rounded text-center" style="background-color:#f5f5f5">
                <img src="@/assets/img/user/noPicUser.png" class="img-fluid" style="padding:5%"/>
                <h5>{{userData.fullname}}</h5>
                User Type : <span class="h5">{{userData.role}}</span>
            </div>
            <div class="col-md-9  col-sm-12 " style="padding-left:3%">
                <panel class="border border-secondary" :noButton='true' style="margin-bottom : 0;">
                    <template slot="header">
                        <h4 class="panel-title">Profile Account</h4>
                    </template>

                    <p style="color:red">{{errorText}}</p>

                    <!-- <div class="form-group">
                        <label>Name</label>
                        <input type="text" placeholder="Name" class="form-control" v-model='updateData.name'/>
                    </div> -->
                    <!-- <hr> -->
                    <h5>Change Password Option</h5>
                    <div class="form-group">
                        <label>Old Password</label>
                        <input type="password" placeholder="Old Password" class="form-control" v-model='updateData.old_password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password</label>
                        <input type="password" placeholder="New Password" class="form-control" v-model='updateData.new_password'/>
                    </div>
                    <div class="form-group">
                        <label>New Password Confirmation</label>
                        <input type="password" placeholder="New Password Confirmation" class="form-control" v-model='confirm_password'/>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary w-25 p-5" v-on:click="updateProfile()">Edit Profile</button>
                    </div>
                    
                </panel>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    metaInfo: {
      title: 'Edit Profile',
      titleTemplate: '%s - QTrust',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    },
    data(){
        return{
            currentComponent : '',
            userData : null,
            updateData : {
                name : '',
                old_password : null,
                new_password : null,
            },
                confirm_password : null,
            errorText: ''
        }
    },
    mounted(){
        this.userData = this.$store.state.userData.userData
        this.updateData.name = this.userData.fullname
    },
    watch:{
        
    },
    methods:{
        updateProfile(){
            this.errorText = ''

            if(!this.updateData.old_password){
                // this.$emit('triggerAlert', false, [`${this.capitalize(this.form.type)} ${vm.form.username} has been successfully changed`]);
                this.$swal.fire({
                    title : "Error!",
                    icon : "error",
                    text : "Please Insert Old Password Before Continuing."
                })
                return;
            }

            if(!this.updateData.new_password){
                // this.$emit('triggerAlert', false, [`${this.capitalize(this.form.type)} ${vm.form.username} has been successfully changed`]);
                this.$swal.fire({
                    title : "Error!",
                    icon : "error",
                    text : "Please Insert New Password Before Continuing."
                })
                return;
            }

            if(!this.confirm_password){
                // this.$emit('triggerAlert', false, [`${this.capitalize(this.form.type)} ${vm.form.username} has been successfully changed`]);
                this.$swal.fire({
                    title : "Error!",
                    icon : "error",
                    text : "Please Insert Confirm Password Before Continuing."
                })
                return;
            }

            if(this.updateData.new_password != this.confirm_password){
                // this.$emit('triggerAlert', false, [`${this.capitalize(this.form.type)} ${vm.form.username} has been successfully changed`]);
                this.$swal.fire({
                    title : "Error!",
                    icon : "error",
                    text : "New Password and Confirmation Password is not the same. Please Try Again."
                })
                return;
            }

            this.$http.post('/api/auth/update-profile' , this.updateData)
            .then((resp)=>{
                         
                this.$swal.fire({
                    title : "Success!",
                    icon : "success",
                    text : "Successfully Updated User Profile"
                })
                this.$store.dispatch('setUser', resp.data.data);
            })
            .catch((err)=>{
                console.log(err);
                this.$swal.fire({
                    title : "Error!",
                    icon : "error",
                    text : err.response.data.message
                })
            })
        }
    }
}
</script>